export const TitleLineCurve = {
  initialAxis: {
    x: -550,
    y: -800,
  },
  initialControlPoint: {
    x: 200,
    y: -200,
  },
  endingControlPoint: {
    x: 800,
    y: -200,
  },
  endingAxis: {
    x: 1150,
    y: 0,
  },
};



// WEBPACK FOOTER //
// ./src/components/Title/constants.js